/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { Modal } from 'ant-design-vue'

if (process.env.NODE_ENV === 'production' && (process.env.VUE_APP_PWA || 'false') === 'true') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n'
        + 'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')

      Modal.confirm({
        title: '系统提示',
        content: '系统已经更新成功，刷新后即可生效',
        okText: '立即刷新',
        cancelText: '稍后刷新',
        onOk () {
          window.location.reload()
        },
        onCancel () {}
      })
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
